import { META_FALLBACK_IMAGE } from '../constants';
import { fullCentreTitle } from './full-centre-title';
import { getCentreStructuredData } from './get-centre-structured-data';
export const getDefaultCentreMetadata = _ref => {
  let {
    canonical,
    centre,
    description: shortDescription,
    title: contentTitle,
    imageUrl
  } = _ref;
  const title = contentTitle || fullCentreTitle(centre);
  const description = shortDescription || "Westfield ".concat(centre.title, " - your one-stop hub for shopping, fun & relaxation. Shop our range of fashion, entertainment, dining & wellbeing or check out great events & activities.");
  return {
    title,
    description,
    // TODO: In event a url is not available don't return incomplete structured data
    openGraphData: canonical ? {
      url: canonical,
      type: 'ShoppingCenter',
      title,
      description,
      image: imageUrl || META_FALLBACK_IMAGE
    } : null,
    schema: getCentreStructuredData({
      url: canonical,
      centre,
      imageUrl,
      name: title,
      description
    })
  };
};